import type { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ErrorBoundary } from "@components/errors/ErrorBoundary/ErrorBoundary";
import { PerimeterHeader } from "@components/PerimeterHeader/PerimeterHeader";
import { ReferencesProvider } from "@contexts/References/References.context";
import { SelectedPerimetersProvider } from "@contexts/SelectedPerimeters/SelectedPerimeters.context";
import { useGroupsDropdown } from "@hooks/useGroupsDropdown";
import { ROUTES } from "@router/router.constants";

import classes from "./PerimeterLayout.module.css";
import type { PerimeterLayoutProps } from "./PerimeterLayout.types";

export const PerimeterLayout: FC<PerimeterLayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const resetPerimNavigation = () => {
    if (
      pathname !== ROUTES.PERIMETER_CUSTOMERS &&
      pathname !== ROUTES.PERIMETER_CONTRACTS &&
      pathname !== ROUTES.PERIMETER_SITES
    ) {
      navigate(ROUTES.PERIMETER_CUSTOMERS);
    }
  };

  const { groupsDropdownOptions, groupsOnDropdownChange, groupsDropdownValue } =
    useGroupsDropdown([resetPerimNavigation]);

  return (
    <ReferencesProvider>
      <SelectedPerimetersProvider>
        <PerimeterHeader
          groupsDropdownOptions={groupsDropdownOptions}
          groupsDropdownValue={groupsDropdownValue}
          groupsOnDropdownChange={groupsOnDropdownChange}
        />
        {/* This error boundary is there to catch errors inside the pages while leaving access
          to the internal navigation of the page (ie. breadcrumb) */}
        <ErrorBoundary pathname={pathname}>
          <div className={classes.container}>{children}</div>
        </ErrorBoundary>
      </SelectedPerimetersProvider>
    </ReferencesProvider>
  );
};
